/**
 * @generated SignedSource<<9aeaeb146145811320916db1f5c32491>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionModalReactions_contribution",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContributionAuthorizations",
      "kind": "LinkedField",
      "name": "authorizations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "votesDisplayAuthorized",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "votesSubmissionAuthorized",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bookmarksCreationAuthorized",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReactableMeasures_reactable"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VoteButtons_votable"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionBookmarkButton_contribution"
    }
  ],
  "type": "Contribution",
  "abstractKey": null
};

node.hash = "788a9c29df3f43d38c56a0aabc0c4500";

module.exports = node;
